import camelCase from 'lodash/camelCase'
import { combineReducers } from 'redux'
import devicesNew from 'features/Devices/devicesSlice'
import installationsNew from 'features/Devices/installationsSlice'
import camerasNew from 'features/Cameras/camerasSlice'
import camerasView from 'features/CamerasView/camerasViewSlice'
import intercoms from 'features/Intercoms/intercomsSlice'
import warranty from 'features/Warranty/warrantySlice'
import keysPro from 'features/Keys/keysProSlice'
import masterKeys from 'features/MasterKeys/masterKeysSlice'
import addressLists from 'features/AddressLists/addressListsSlice'
import assignKeys from 'features/AssignKeys/assignKeysSlice'
import admin from 'features/Admin/adminSlice'
import { citizensProReducer } from 'features/CitizensListPro'
import { releaseNotesReducer } from 'features/ReleaseNotes/model/releaseNotesSlice'
import homeV2 from 'features/HomeV2/model/homeSlice'

const reducers = {
  homeV2,
  devicesNew,
  installationsNew,
  camerasNew,
  camerasView,
  warranty,
  keysPro,
  intercoms,
  masterKeys,
  addressLists,
  assignKeys,
  admin,
  citizensPro: citizensProReducer,
  releaseNotes: releaseNotesReducer,
}

const req = require.context('.', true, /\.\/.+\/reducers\.js$/)

req.keys().forEach((key) => {
  const storeName = camelCase(key.replace(/\.\/(.+)\/.+$/, '$1'))
  reducers[storeName] = req(key).default
})

export default combineReducers(reducers)
